export class AbstractDialogClasses {
}

export class HtmlContentDialogModel {
  constructor(public header: string, public content: string, public isCompact = false) {}
}

export class HtmlContentDialogResult {
  constructor(public submitted: boolean, public content: string) { }
}

export class HtmlContentDialogModelObject {
  constructor(
    public header: string,
    public objArray: any[]
  ) {}
}

export class HtmlContentDialogResultObject {
  constructor(
    public submitted: boolean,
    public objArray: any[]
  ) {}
}
